import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ComfortTradeModal = ({ isOpen, setIsOpen }) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={<p className='text-center'>{t('whatIsComfortTrade')}</p>}
            visible={isOpen}
            onOk={() => {}}
            onCancel={() => setIsOpen(false)}
            footer={false}
            size='small'
        >
            <p className='text-center mt-3'>{t('comfortTradeDescription')}</p>
        </Modal>
    );
}

export default ComfortTradeModal;
